var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
    'search-icon': !_vm.showMenu,
    'close-icon': _vm.showMenu
  },attrs:{"aria-expanded":_vm.showMenu.toString(),"aria-label":"Search"},on:{"click":_vm.handleTriggerMenu}})}
var staticRenderFns = []

export { render, staticRenderFns }